import type { IconType } from '@/lib/icons'
import { CircleX, Clapperboard, Eye, Send, Wallet } from '@/lib/icons'
import { VideoStage } from '@ayub/shared'

/**
 * Har bir video bosqichi uchun ikonka va rang — `docs/04-ui-ux.md` "Holat ranglari (varonka)"
 * jadvaliga mos: Moderatsiya amber, Joylandi ko'k, PM Tekshiruvda binafsha, To'landi yashil,
 * Rad etildi qizil. Ranglar `index.css`dagi `--color-stage-*` tokenlaridan olinadi — bu yerda
 * qattiq hex yozilmaydi.
 *
 * Nomlar (`VIDEO_STAGE_LABELS`) `@ayub/shared`da tayyor va bloger varonkasidan farqli o'laroq
 * kanban sarlavhasi bilan chip nomi bir xil — shuning uchun bu yerda alohida label jadvali yo'q.
 */
interface StageMeta {
  icon: IconType
  textClass: string
  borderClass: string
  dotClass: string
  subtleClass: string
}

export const VIDEO_STAGE_META: Record<VideoStage, StageMeta> = {
  [VideoStage.MODERATION]: {
    icon: Clapperboard,
    textClass: 'text-stage-moderation-text',
    borderClass: 'border-stage-moderation',
    dotClass: 'bg-stage-moderation',
    subtleClass: 'bg-stage-moderation/10',
  },
  [VideoStage.POSTED]: {
    icon: Send,
    textClass: 'text-stage-posted-text',
    borderClass: 'border-stage-posted',
    dotClass: 'bg-stage-posted',
    subtleClass: 'bg-stage-posted/10',
  },
  [VideoStage.CHECKING]: {
    icon: Eye,
    textClass: 'text-stage-checking-text',
    borderClass: 'border-stage-checking',
    dotClass: 'bg-stage-checking',
    subtleClass: 'bg-stage-checking/10',
  },
  [VideoStage.PAID]: {
    icon: Wallet,
    textClass: 'text-stage-paid-text',
    borderClass: 'border-stage-paid',
    dotClass: 'bg-stage-paid',
    subtleClass: 'bg-stage-paid/10',
  },
  [VideoStage.REJECTED]: {
    icon: CircleX,
    textClass: 'text-stage-rejected-text',
    borderClass: 'border-stage-rejected',
    dotClass: 'bg-stage-rejected',
    subtleClass: 'bg-stage-rejected/10',
  },
}
